import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import api from '../services/api';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      refreshToken: null,
      isAuthenticated: false,
      tenantId: null,
      
      // Inicializa token no header se existir
      initializeAuth: () => {
        const { token } = get();
        if (token) {
          api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
      },
      
      login: async (email, password) => {
        try {
          const response = await api.post('/auth/login', { email, password });
          const { data } = response.data;
          
          set({
            user: data.user,
            token: data.access_token,
            refreshToken: data.refresh_token,
            isAuthenticated: true,
            tenantId: data.user.tenant_id,
          });
          
          // Configura token no header das requisições
          api.defaults.headers.common['Authorization'] = `Bearer ${data.access_token}`;
          
          return { success: true };
        } catch (error) {
          console.error('Login error:', error);
          return {
            success: false,
            error: error.response?.data?.message || error.message || 'Erro ao fazer login',
          };
        }
      },
      
      register: async (name, email, password, passwordConfirmation) => {
        try {
          const response = await api.post('/auth/register', { 
            name, 
            email, 
            password, 
            password_confirmation: passwordConfirmation 
          });
          const { data } = response.data;
          
          set({
            user: data.user,
            token: data.access_token,
            refreshToken: data.refresh_token,
            isAuthenticated: true,
            tenantId: data.user.tenant_id, // Pode ser null se ainda não tem tenant
          });
          
          // Configura token no header das requisições
          api.defaults.headers.common['Authorization'] = `Bearer ${data.access_token}`;
          
          return { success: true };
        } catch (error) {
          console.error('Register error:', error);
          return {
            success: false,
            error: error.response?.data?.message || error.message || 'Erro ao criar conta',
          };
        }
      },
      
      logout: () => {
        set({
          user: null,
          token: null,
          refreshToken: null,
          isAuthenticated: false,
          tenantId: null,
        });
        
        delete api.defaults.headers.common['Authorization'];
      },
      
      refreshAccessToken: async () => {
        const { refreshToken } = get();
        
        if (!refreshToken) {
          get().logout();
          return false;
        }
        
        try {
          const response = await api.post('/auth/refresh', {
            refresh_token: refreshToken,
          });
          
          const { data } = response.data;
          
          set({
            token: data.access_token,
            refreshToken: data.refresh_token,
          });
          
          api.defaults.headers.common['Authorization'] = `Bearer ${data.access_token}`;
          
          return true;
        } catch (error) {
          console.error('Refresh token error:', error);
          get().logout();
          return false;
        }
      },
      
      setTenantId: (tenantId) => {
        set({ tenantId });
      },
    }),
    {
      name: 'haklai-auth-storage',
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        // Inicializa token após reidratação do localStorage
        if (state?.token) {
          api.defaults.headers.common['Authorization'] = `Bearer ${state.token}`;
        }
      },
    }
  )
);

// Inicializa auth ao carregar o módulo (apenas no browser)
if (typeof window !== 'undefined') {
  useAuthStore.getState().initializeAuth();
}

